import ApiProfile from './api.profile';
/*import ApiTfa from './api.tfa';*/
import BasicService from './basic.service'

declare var firebase;
declare var location;

class AuthService extends BasicService {

  constructor() {
    super();

    const userData = localStorage.getItem('userData');
    const registerData = localStorage.getItem('registerData');
    const company_code = localStorage.getItem('company_code');

    this.isLogged = false;  //??
    this.service = new ApiProfile();
    
    this.company_code = company_code;
    
    this.profileUser = userData;
    this.registerData = registerData;
    

    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        localStorage.setItem('registerData', JSON.stringify(user));
        this.registerData = user;
        this.emit('firebaseLogin', { registerData: user });

        // Retirado pois nao faz sentido dar o refresh so porque o AuthStateChanged -
	      // Testando esta solucao
	      // Pode haver reflexos...
	      
        //if (this.profileUser) {
        //  this.saveProfileLocal(JSON.parse(this.profileUser));
        //} else {
        //  this.refresh();
        // }
      }
    });

    if (userData && registerData) {
      this.profileUser = JSON.parse(userData);
      this.registerData = JSON.parse(registerData);
      this.refresh();
    }

    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.refresh = this.refresh.bind(this);
    this.create = this.create.bind(this);
    this.emit = this.emit.bind(this);
    this.update = this.update.bind(this);
    this.saveProfileLocal = this.saveProfileLocal.bind(this);
  }

  login() {
    let provider = new firebase.auth.GoogleAuthProvider();
    provider.addScope('https://www.googleapis.com/auth/plus.login');
    firebase.auth().useDeviceLanguage();

    let company_code = localStorage.getItem('company_code');
    //console.log(company_code);

    firebase.auth().signInWithPopup(provider)
	    .then(loginData => {
	     
	    	this.registerData = loginData.user;
	      localStorage.setItem('registerData', JSON.stringify(this.registerData));
	
	      //debugger;
		    
		    let register = {
	          uid: this.registerData.uid,
	          name: this.registerData.displayName,
	          email: this.registerData.email,
	          company_code: company_code
        };
	
	      if(loginData.additionalUserInfo.isNewUser) {
	        this.create(register);
	      } else {
		    
			    new ApiProfile().getByUid(company_code, this.registerData.uid)
			      .then (response => {
			        let profile = response.data;
			        
			        if (profile) {
			          
			          this.saveProfileLocal(profile);
			          let data = {
						      registerData: this.registerData,
						      profile: profile
					      };
					      this.emit('profileLoaded', data);
			        }
			        else { this.create(register); }
			        
	        }).catch(err => {
		          console.log('User not found. Create...');
		          this.create(register);
		      });
		      }
	      /*debugger;*/
	      //this.refresh();

    } , (err) => {
	      if (err.code !== 'auth/cancelled-popup-request') {
	        this.emit('messageModal', { title: 'Login Fail', message: err.message });
      }
    });
  }

  logout() {
    firebase.auth().signOut().then(() => {
      window.localStorage.removeItem('userData');
      window.localStorage.removeItem('registerData');
      window.localStorage.removeItem('token');
      //window.localStorage.clear();
      //this.profile = {};
      this.profileUser = null;
      this.registerData = null;

      let data = {
        registerData: null,
        profile: null
      };
      this.emit('profileLogout', data);
	    
      //this.currentUser = {};
      //this.registerData = {};

      //if (window.location.href.includes('profile')) {
      //  window.location.href = window.location.origin;
      //} else {
      //  window.location.reload();
      //}
	    
	    window.location.replace("/");

      
    }, (error) => {
      this.emit('messageModal', {
        title: 'Logout Fail',
        message: 'Something wrong happened with your logout... We are checking...'
      });
    });
  }

  update(profile, type) {
    return new Promise((resolve, reject) => {
      if (type && type === 'tfa' && profile.tfa) {
        profile['tfa_token'] = profile.tfa.token;
      }
      new ApiProfile().put(this.company_code, profile).then(response => {
        this.saveProfileLocal(profile);
        resolve(response.data);
      }).catch(() => {
        reject();
      });
    });

  }

  refresh() {
    if (this.registerData) {  /* currentUser.uid ??? */
	    new ApiProfile().getByUid(this.company_code, this.registerData.uid)
		    .then(response => {
			    let profile = response.data;
			    
			    if (profile) {
				
				    this.saveProfileLocal(profile);
				
				    let data = {
					    registerData: this.registerData,
					    profile: profile
				    };
				    this.emit('profileLoaded', data);
				    
			    }
	    });
    }
  }

  create(regData) {
    new ApiProfile().createProfile(regData).then(response => {
      if (response.data) {
        //localStorage.setItem('userData', JSON.stringify(response.data));
	      
	      let profile = response.data;
	      
	      if (profile) {

	        this.saveProfileLocal(profile);
	        this.refresh();
	        this.emit('messageModal', {
	          title: 'Profile Created',
		        message: "Criamos uma conta Winvite para vc..."
	        })
	      } else {
	      	this.emit('messageModal', {
	          title: 'Erro criando conta...',
		        message: "Nao conseguimos criar a sua conta Winvite..."
	        })
	      }
      }
    }).catch(err => {
      console.log(err);
      console.log('Error creating user account...');
    });
  }

  emit(eventName, data) {
    let event = new CustomEvent(eventName, { detail: data });
    document.dispatchEvent(event);
  }

  saveProfileLocal(profile) {

    this.profileUser = profile;

    let profileStringfy = JSON.stringify(profile);
    localStorage.setItem('userData', profileStringfy);

    //let data = {
    //  registerData: this.registerData,
    //  profile: profile
    //};
    //this.emit('profileLoaded', data);
  }
}

export default new AuthService();


// WEBPACK FOOTER //
// ./src/utils/auth.service.js